import { useState } from "react";
import {  loadVendorListByTypeDesc } from "../services/vendorEnquiryService";

const useVendorListByTypeDesc = () => {
    const [partyByType, setPartyByType] = useState([]);
    const [selectedpartyByTypeID, setSelectedpartyByTypeID] = useState(0);
    const [selectedpartyByType, setSelectedpartyByType] = useState([]);


    const loadPartyListByCategory = async (selectedID = null, categoryDescription) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_party_type_desc: categoryDescription
        };

        try {
            const data = await loadVendorListByTypeDesc(para);
            if (data && data.length > 0) {
                setPartyByType(data); // Assumes backend returns `material_code`

                const initialEmployee = data.find((dept) => dept.id === selectedID) || [];
                if (initialEmployee) {
                    setSelectedpartyByType(initialEmployee);
                    setSelectedpartyByTypeID(initialEmployee.id);
                }
            }
        } catch (error) {
            console.error("Failed to generate material code:", error);
        }
    };



    return {
        partyByType,
        selectedpartyByTypeID,
        selectedpartyByType,
        setPartyByType,
        setSelectedpartyByTypeID,
        setSelectedpartyByType,
        loadPartyListByCategory,
    };
};

export default useVendorListByTypeDesc;